export default "__VITE_ASSET__DKwrKOdC__"